// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jj-6";
export var emphasizeQuantity = "_jj-3";
export var flatBottomCorners = "_jj-5";
export var productImage = "_jj-0";
export var quantityContainer = "_jj-2";
export var tooltip = "_jj-1";
export var wrapAndEllipsesOverflow = "_jj-4";